<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <AppHeader :title="$t('library_reservation')"
                        :isNewButton="false"
                        @filter-div-status="datatable.filterStatus = $event">
                </AppHeader>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('library_reservation')"
                              :isNewButton="false"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <DatatableFilter
             v-show="datatable.filterStatus"
             :exportExcel="true"
             @filter="filter" @filterClear="filterClear" :export-excel="checkPermission('libraryreservation_excelexport')"  @exportExcel="exportExcel">
                <b-row>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
<!--                    <b-col sm="6" md="3">-->
<!--                        <b-form-group :label="$t('faculty')">-->
<!--                            <FacultySelectbox-->
<!--                                v-model="datatable.queryParams.filter.faculty_id"-->
<!--                            />-->
<!--                        </b-form-group>-->
<!--                    </b-col>-->
<!--                    <b-col sm="6" md="3">-->
<!--                        <b-form-group :label="$t('program')">-->
<!--                            <ProgramSelectbox-->
<!--                                v-model="datatable.queryParams.filter.program_id"-->
<!--                            />-->
<!--                        </b-form-group>-->
<!--                    </b-col>-->
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('library_rooms')">
                            <LibraryRoomSelectbox
                                v-model="datatable.queryParams.filter.library_room_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('library_chairs')">
                            <library-chair-selectbox v-model="datatable.queryParams.filter.library_chair_id" :room-id="datatable.queryParams.filter.library_room_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('date')">
                            <SelectDate v-model="datatable.queryParams.filter.date"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input type="time" size="sm" v-model="datatable.queryParams.filter.start_time"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input type="time" size="sm" v-model="datatable.queryParams.filter.end_time"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </DatatableFilter>

            <Datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </Datatable>

            <!-- Status Change Modal -->
            <CommonModal ref="statusChangeModal" size="md">
                <template v-slot:CommonModalTitle>
                    {{ $t('change_status') }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-form-group :label="$t('status')">
                        <ParameterSelectbox v-model="statusForm.status" code="library_reservation_statuses" />
                    </b-form-group>
                    <div class="d-flex justify-content-end">
                        <b-button variant="primary" @click="updateReservationStatus" :disabled="datatable.isLoading">
                            {{ $t('save') }}
                        </b-button>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import AppHeader from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import Datatable from "@/components/datatable/Datatable.vue";
import DatatableFilter from "@/components/datatable/DatatableFilter.vue";
import CommonModal from "@/components/elements/CommonModal.vue";
import LibraryRoomSelectbox from "@/components/interactive-fields/LibraryRoomSelectbox.vue";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox.vue";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox.vue";
import LibraryReservationService from "@/services/LibraryReservationService";
import qs from 'qs';
import LibraryChairSelectbox from "@/components/interactive-fields/LibraryChairSelectbox.vue";

export default {
    name: "LibraryReservationAdminIndex",
    components: {
        LibraryChairSelectbox,
        AppLayout,
        AppHeader,
        HeaderMobile,
        Datatable,
        DatatableFilter,
        CommonModal,
        LibraryRoomSelectbox,
        FacultySelectbox,
        ProgramSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('library_reservation')
        }
    },
    data() {
        return {
            statusForm: {
                id: null,
                status: null
            },
            statusOptions: [
                { value: 'approved', text: this.$t('approved') },
                { value: 'participated', text: this.$t('participated') },
                { value: 'canceled', text: this.$t('canceled') },
                { value: 'not_participated', text: this.$t('not_participated') }
            ],
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('change_status'),
                                class: 'ri-settings-3-line',
                                permission:'libraryreservation_changestatus',
                                callback: (row) => {
                                    this.openStatusModal(row);
                                }
                            }
                        ]
                    },
                    { label: this.$t('student_number'), field: 'number', sortable: false },
                    { label: this.$t('name'), field: 'name', sortable: false },
                    { label: this.$t('surname'), field: 'surname', sortable: false },
                    // { label: this.$t('faculty'), field: this.getLocaleField('faculty_name'), sortable: false },
                    // { label: this.$t('program'), field: this.getLocaleField('program_name'), sortable: false },
                    { label: this.$t('library_rooms'), field: 'library_room_name', sortable: false },
                    { label: this.$t('library_chairs'), field: 'library_chair_name', sortable: false },
                    { label: this.$t('date'), field: 'date', sortable: false },
                    { label: this.$t('start_time'), field: 'start_time', sortable: false },
                    { label: this.$t('end_time'), field: 'end_time', sortable: false },
                    {
                        label: this.$t('status'),
                        field: 'status_name',
                        sortable: false,
                        formatFn: (value, row) => {
                            let className = 'badge ';
                            switch (row.status) {
                                case 'approved': className += 'badge-success'; break;
                                case 'participated': className += 'badge-info'; break;
                                case 'canceled': className += 'badge-danger'; break;
                                case 'not_participated': className += 'badge-warning'; break;
                                default: className += 'badge-secondary';
                            }
                            return `<span class="${className}">${value}</span>`;
                        }
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: true,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 15
                }
            }
        }
    },
    mounted() {
        this.getRows();
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.isLoading = true;
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            LibraryReservationService.libraryReservation(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .catch((error) => {
                    this.showErrors(error);
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        exportExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                responseType: 'arraybuffer'
            };

            LibraryReservationService.excelExport(config)
                .then(response => {
                    this._downloadFile(response, this.$t('library_reservation') + '.xlsx')
                })
                .catch(error => {
                    this.showErrors(error, null, true)
                });
        },
        openStatusModal(row) {
            this.statusForm.id = row.id;
            this.statusForm.status = row.status;
            this.$refs.statusChangeModal.$refs.commonModal.show();
        },
        updateReservationStatus() {
            this.datatable.isLoading = true;
            LibraryReservationService.cancelReservationAdmin(this.statusForm.id, { status: this.statusForm.status })
                .then((response) => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$refs.statusChangeModal.$refs.commonModal.hide();
                    this.getRows();
                })
                .catch((error) => {
                    this.showErrors(error);
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        }
    }
}
</script>

<style scoped>
</style>
